module.exports = "<div [id]=\"dataGauge.proveedor + 'Gauge'\"></div>"